<template>
    <modal name="gifts-list" @before-open="beforeOpen" @before-close="beforeClose" :classes="['v--modal', 'gifts-list']"
        :width="730" :height="'auto'" :adaptive="true">
        <div class="modal-title">
            {{ $t("myFriends.sendGift") }}
        </div>
        <div class="modal-close" @click="close"></div>
        <div class="modal-body">
            <div class="modal-subtitle">
                {{ $t("sendGift.chooseGift") }}
            </div>
            <div class="tabs">
                <div v-for="(tab, key) in tabs" @click="toggleTabs(tabs, key, checkGifts(key))" class="tabs-item" :key="key"
                    :class="{ 'tabs-current': tab.selected }">
                    {{ tab.text }}
                </div>
            </div>

            <div v-bar class="gifts-list-wrapper">
                <div>
                    <div v-if="loader || initIsEmpty('init') || !init.costs" class="gifts-list-block">
                        <div class="gifts-list-empty">
                            <button class="button-loader"></button>
                        </div>
                    </div>
                    <div v-else>
                        <ul v-for="(giftsList, type) in gifts" v-show="tabs[type].selected" :key="type"
                            class="gifts-list-block">
                            <li v-if="gifts[type].length == 0" class="gifts-list-empty">
                                {{ $t("sendGift.thereCategory") }}
                            </li>
                            <li v-for="(gift, index) in giftsList" :ref="type + index" :key="index" class="gifts-list-item">
                                <div @click="
                                    $modal.show('send-gift', {
                                        gift: gift,
                                        userId: id,
                                    });
                                $modal.hide('gifts-list');
                                " class="gifts-list-image">
                                    <div class="gifts-list-inner">
                                        <div class="gifts-list-img">
                                            <img :src="gift.image" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div class="gifts-list-price">
                                    {{
                                        formatPrice(gift.cost, gift.id) == 0
                                        ? $t("sendGift.free")

                                        : formatPrice(gift.cost, gift.id)
                                    }}
                                </div>
                            </li>
                            <li v-if="moreLoader" class="gifts-list-item">
                                <button class="button-loader"></button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { toggleTabs } from "@/mixins/toggleTabs";
import { clickOutside } from "@/directives.js";
import { observeListEnd } from "@/mixins/observeListEnd";
import { checkScroll } from "@/mixins/checkScroll";

export default {
    name: "GiftsList",
    props: {
        i18n: Object,
    },
    mixins: [toggleTabs, observeListEnd, checkScroll],
    data() {
        return {
            id: "",
            loader: true,
            showContext: false,
            tabs: {
                popular: {
                    text: this.$t("sendGift.popularGifts"),
                    observer: null,
                    selected: true,
                },
                bets_and_vip: {
                    text: this.$t("sendGift.bettingVip"),
                    observer: null,
                    selected: false,
                },
                boys: {
                    text: this.$t("sendGift.forMan"),
                    observer: null,
                    selected: false,
                },
                girls: {
                    text: this.$t("sendGift.forGirls"),
                    observer: null,
                    selected: false,
                },
                other: {
                    text: this.$t("sendGift.other"),
                    observer: null,
                    selected: false,
                },
            },
            moreLoader: false,
            moreIndex: 0,
            observer: null,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            gifts: "gifts/fetchGifts",
            giftsIsEmpty: "gifts/isEmpty",
            giftsNext: "gifts/fetchGiftsNext",
            init: "init/fetchInit",
            initIsEmpty: "init/isEmpty",
        }),
    },
    watch: {
        $route(to, from) {
            if (to != from) {
                this.$modal.hide("gifts-list");
            }
        },
    },
    methods: {
        beforeOpen(event) {
            this.checkScroll();
            this.id = event.params.id;
            this.get("popular");
            for (let type in this.tabs) {
                this.tabs[type].observer = new IntersectionObserver(
                    (entries) => {
                        if (
                            entries[0].isIntersecting === true &&
                            this.tabs[type].selected
                        ) {
                            this.showMore(type);
                        }
                    },
                    { threshold: [0] }
                );
            }
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        get(type) {
            this.loader = true;
            this.$store
                .dispatch("gifts/get", type)
                .then(() => {
                    this.updateMoreIndex(type);
                    this.observeListEnd(type, this.tabs);
                    this.loader = false;
                })
                .catch(() => {
                    this.loader = false;
                });
        },
        checkGifts(type) {
            this.updateTabObserver(type, this.tabs);
            if (this.gifts[type].length == 0) {
                this.get(type);
            }
        },
        updateMoreIndex(type) {
            this.tabs[type].moreIndex = this.gifts[type].length - 2;
        },
        clickOutsideContext() {
            this.showContext = false;
        },
        formatPrice(price, gift = false) {
            if (this.user.vip && gift >= 7) {
                return Math.ceil((price * (100 - this.init.costs.vip_discount)) / 100);
            }
            let arr = price.split(".");
            return arr[1] == "00" ? arr[0] : price;
        },
        showMore(type) {
            if (this.giftsNext[type]) {
                this.moreLoader = true;
                this.$store
                    .dispatch("gifts/getNext", type)
                    .then(() => {
                        this.updateMoreIndex(type);
                        this.observeListEnd(type, this.tabs, true, true);
                        this.moreLoader = false;
                    })
                    .catch(() => {
                        this.moreLoader = false;
                    });
            } else {
                this.observeListEnd(type, this.tabs, true);
            }
        },
        close() {
            this.toggleTabs(this.tabs, "popular");
            this.$modal.hide("gifts-list");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_tabs";
</style>

<style lang="scss">
@import "~@/assets/styles/layout/_gifts-list";
</style>
